import { render, staticRenderFns } from "./flowAddComment.vue?vue&type=template&id=2b5984e6&"
import script from "./flowAddComment.vue?vue&type=script&lang=js&"
export * from "./flowAddComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/flow/flowAddComment.vue"
export default component.exports